module.exports = __webpack_public_path__ + "static/media/logo_white.4e8cd4b1.png";